module.exports = __webpack_public_path__ + "img/sales-manager.eeacb1a2.png";